// extracted by mini-css-extract-plugin
export default {"wrap":"skin2-module_wrap_HqFKb","player":"skin2-module_player_ttHSx","playList":"skin2-module_playList_jcziF","playItem":"skin2-module_playItem_KF4Ug"};